import React, { createRef, useEffect, useState } from "react";
import "./Catalog.css";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { useNavigate } from "react-router-dom";
import { Button, Checkbox, Flex, Grid, MultiSelect, Stack, TextInput } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import GlassCard from "../../components/GlassCard/GlassCard";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import axios from "axios";
import moment from "moment/moment";
import { errorHandler } from "../../utils/errorHandler";
import showNotification from "../../utils/showNotification";
import { ROUTES_PATHNAME } from "../../routes/dict";
import PhoneInputField from "../../components/PhoneInputField/PhoneInputField";
import { useForm } from "@mantine/form";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useAppContext } from "../../context/AppState/AppContext";
const CATALOG_URL = "https://forvet-main.s3.sa-east-1.amazonaws.com/public/misc/forvet-catalog-2026.pdf";
const MONTHS_DICT = {
    'enero': 0,
    'febrero': 1,
    'marzo': 2,
    'abril': 3,
    'mayo': 4,
    'junio': 5,
    'julio': 6,
    'agosto': 7,
    'septiembre': 8,
    'octubre': 9,
    'noviembre': 10,
    'diciembre': 11
};

function Catalog() {
    const { specialtiesInfo } = useAppContext();


    const form = useForm({
        initialValues: {
            email: '',
            phone: '',
            name: "",
            is_slack: false,
        },

        validate: {
            name: (value) => (value.length > 5 ? null : 'Ingrese su nombre completo'),
            email: (value) => (/^\S+@\S+$/.test(value) ? null : 'El email ingresado no es valido'),
            phone: (value) => {
                if (typeof value === "string")
                    return !isValidPhoneNumber(value)
                else return true
            }
        },
    });
    const [specialtiesData, setSpecialtiesData] = useState([])
    const [coursesData, setCoursesData] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const getCoursesData = () => {
        const url = process.env.REACT_APP_BACKEND_SERVER + `/info/academicUnits`;
        axios
            .get(url)
            .then((res) => {
                // Sort courses by date
                const openedCourses = res.data.open.map((_oCourse) => {
                    // Filter courses outsideCampus (openSource webinars)
                    if (_oCourse.comercialInformation.outsideCampus) return null;
                    const dateParts = _oCourse.comercialInformation.initialDate.split(" ")
                    const datePartsLower = dateParts.map(el => el.toLowerCase());
                    if (datePartsLower.includes("de")) {
                        datePartsLower.splice(datePartsLower.indexOf("de"), 1);
                    }

                    const month = MONTHS_DICT[datePartsLower[1].toLowerCase()];
                    const date = moment({
                        day: datePartsLower[0],
                        month: month,
                        year: datePartsLower[2]
                    });

                    return {
                        ..._oCourse,
                        startDate: date
                    }
                }).filter(el => el !== null)
                openedCourses.sort((a, b) => b.startDate - a.startDate);

                setCoursesData(openedCourses);
            })
            .catch((err) => {
                console.log(err)
                const errorMessage = errorHandler(err)
                showNotification({
                    color: 'red',
                    status: 'error',
                    title: 'Operación fallida.',
                    message: `Detalles: ${errorMessage}`,
                })
            })
    }

    const ref = createRef()

    useEffect(() => {
        if (!coursesData) getCoursesData();
    }, []);

    const handleSubmit = async (values) => {
        setLoading(true);

        try {
            const { email, phone, name, specialties = [], is_slack = false } = values;

            if (is_slack) {
                try {
                    let slack_message = `Mensaje enviado desde la pagina de catálogo por ${name} (email: ${email} - celular: ${phone}). El usuario solicita contacto de un asesor.`;

                    if (specialties.length > 0) {
                        slack_message += `\nEspecialidades de interés: ${specialties.join(", ")}`;
                    }

                    await axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/info/slack`, {
                        channel: 'web-soporte',
                        message: slack_message
                    });
                } catch (slackErr) {
                    console.error("Error al notificar a Slack:", slackErr);
                }
            }

            const createLeadJsonData = {
                email: email,
                phone: phone,
                interestAreas: Array.isArray(specialties) ? specialties : [specialties],
                source: 'CATALOG',
                sendEmail: true,
                fileUrls: [CATALOG_URL]
            };

            await axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/info/createLead`, createLeadJsonData);

            const successMessage = is_slack
                ? "Tus datos se enviaron. Recibirás el catálogo por mail y un asesor te contactará pronto."
                : "¡Listo! Revisá tu casilla de correo para ver el catálogo.";

            showNotification({
                title: "¡Catálogo enviado correctamente!",
                message: successMessage,
                color: "green",
            });

            localStorage.setItem("FVW-CATALOG-2026", "true");
            form.reset()
        } catch (error) {
            console.error("Error crítico en handleSubmit:", error);
            showNotification({
                color: "red",
                title: "Error",
                message: "No pudimos procesar tu solicitud. Por favor, reintenta en unos instantes.",
            });
        } finally {

            setLoading(false);
        }
    };

    useEffect(() => {
        if (specialtiesInfo?.data) {
            setSpecialtiesData(specialtiesInfo?.data.map(specialty => specialty.name.toUpperCase()));
        }
    }, [specialtiesInfo]);


    return (
        <MainLayout overflow="hidden">
            <div className="Catalog__container">
                <div className="Catalog__column">
                    <Stack p={0} gap={0} align="center">
                        <h1 className="Catalog__title">
                            Catálogo <br />
                            <span className="Catalog__gradient">
                                de Cursos 2026
                            </span>
                        </h1>
                        <p className="Catalog__text">
                            Encuentra la capacitación que necesitas para potenciar tu carrera profesional.
                        </p>
                    </Stack>

                    

                    <div className="Catalog__form">

                        <form
                            style={{
                                width: "100%",
                                color: 'var(--color-text-primary)'
                            }}
                            onSubmit={
                                form.onSubmit((values) => handleSubmit(values))
                            }>
                            <Grid>
                                <Grid.Col span={{ base: 12, sm: 6 }}>
                                    <TextInput
                                        placeholder="Juan Perez"
                                        required
                                        label='Escribe tu nombre'
                                        {...form.getInputProps('name')}
                                    />
                                </Grid.Col>
                                <Grid.Col span={{ base: 12, sm: 6 }}>
                                    <TextInput
                                        placeholder="ejemplo@gmail.com"
                                        required
                                        label='Escribe tu email'
                                        {...form.getInputProps('email')}
                                    />
                                </Grid.Col>
                                <Grid.Col span={12}>
                                    <PhoneInputField
                                        ref={ref}
                                        required
                                        name="phone"
                                        fieldError={form.errors.phone}
                                        {...form.getInputProps("phone")}
                                    />
                                </Grid.Col>
                                <Grid.Col span={12}>
                                    {specialtiesData && <MultiSelect
                                        data={specialtiesData}
                                        label='Especialidades de interés'
                                        {...form.getInputProps('specialties')}
                                    />}
                                </Grid.Col>

                                <Grid.Col span={12}>
                                    <Checkbox
                                        label='Quiero que un asesor me contacte'
                                        {...form.getInputProps('is_slack')}
                                    />
                                </Grid.Col>

                                <Grid.Col span={12}>
                                    <Flex w='100%' justify='center'>
                                        <Button type='submit' w='max-content' loading={loading} leftIcon={<IconDownload />} color='var(--color-tertiary)' disabled={loading}>
                                            {form.values?.is_slack ? "Recibir catálogo y asesoramiento" : "Recibir Catálogo"}
                                        </Button>
                                    </Flex>
                                </Grid.Col>
                            </Grid>
                        </form>

                    </div>

                    <div className="Catalog__alternative">
                        <Button
                            onClick={() => navigate(ROUTES_PATHNAME.courses.href)}
                            variant="transparent"
                            color="var(--color-text-primary)"
                        >
                            Ver próximos inicios en la web
                        </Button>
                    </div>
                </div>

                <div className="Catalog__column">
                    {coursesData && (
                        <Splide
                            options={{
                                type: "loop",
                                drag: "free",
                                focus: "center",
                                autoWidth: true,
                                gap: 40,
                                arrows: false,
                                pagination: false,
                                autoScroll: {
                                    speed: 1,
                                },
                            }}
                            extensions={{ AutoScroll }}
                        >
                            {coursesData.map((item) => (
                                <SplideSlide>
                                    <GlassCard
                                        item={{
                                            ...item,
                                            photo: item.comercialInformation.image,
                                            name: item.comercialInformation.name,
                                        }} />

                                </SplideSlide>
                            ))}
                        </Splide>
                    )}
                </div>
            </div>
        </MainLayout>
    );
}

export default Catalog;
